const types = require('../types');
const isoIec15962 = require('../isoIec15962');

function parse(hexString) {
    // based on https://www.iata.org/en/programs/ops-infra/baggage/rfid/#tab-2
    // RFID Implementation Guide, issue 2.0
    // Section 2.7
    // the "1 0 15961" portion of the common root is the AFI, in decimal

    hexString = hexString.toLowerCase();
    //officially we should start reading 1 word earlier (4 hex characters)
    //those would identify the tag length and the "C1" AFI  (Application Family Identifier)
    //but by default, we don't read those. so lets start at the DSFID
    const dsfid = hexString.substring(0, 2);
    // 0x0c === 12 (decimal)
    if (dsfid != '0c') {
        return null;
    }
    const payload = hexString.substring(2);
    let parsed = isoIec15962.parseNext(payload);
    let result = { hex: hexString.toUpperCase(), type: types.baggage.id };
    while (parsed != null) {
        /* istanbul ignore next */
        switch (parsed.objectId) {
            case 1:
                //fixed 10 digit baggage Identification Number / license plate
                result.baggageIdentificationNumber = parsed.value;
                break;
            case 2:
                //julian day of flight, range 1-366
                result.dayOfFlight = parsed.value;
                break;
            case 3:
                result.securityInformation = parsed.value;
                break;
            case 4:
                result.issueStation = parsed.value;
                break;
            case 5:
                result.baggageRouting = parsed.value;
                break;
            case 6:
                result.flightData = parsed.value;
                break;
            case 7:
                //unused
                break;
            case 8:
                result.airlineFrequentFlyerLevel = parsed.value;
                break;
            case 9:
                result.screeningAirportCode = parsed.value;
                break;
            case 10:
                result.destinationCode = parsed.value;
                break;
            case 11:
                result.internalAirportStatus = parsed.value;
                break;
            //door to door delivery service:
            case 90:
                result.d2dIssueDate = parsed.value;
                break;
            case 91:
                result.d2dSequenceNumber = parsed.value;
                break;
            case 92:
                result.d2dEDSProcessing = parsed.value;
                break;
            case 93:
                result.d2dCollectingCompany = parsed.value;
                break;
            case 94:
                result.d2dInvoice = parsed.value;
                break;
            case 95:
                result.d2dDeliveringCompany = parsed.value;
                break;
            //OPTIONAL
            case 127:
                result.other = parsed.value;
                break;
            default:
                break;
        }
        if (!parsed.remainder) {
            parsed = null;
        } else {
            parsed = isoIec15962.parseNext(parsed.remainder);
        }
    }

    result.toString = function () {
        return `urn:epc:tag:${result.type}:${result.baggageIdentificationNumber}.${result.dayOfFlight}`;
    };
    return result;
}

module.exports = {
    parse
};
